import { DataField } from './datafield';
import { DataFieldValue } from './datafield-value';

export class DataFieldGroup {
    constructor(
        public DataFieldGroupId: number = undefined,
        public DisplayName: string = undefined,
        public SortOrder: number = undefined,
        public Description: string = undefined,
        public DataFields: DataField[] = undefined) {
    }

    public static getDataFields(datafieldGroups: DataFieldGroup[]): DataField[] {
        const dataFields = (datafieldGroups || [] as DataFieldGroup[])
            .map(e => e.DataFields || [] as DataField[])
            .reduce((a, b) => a.concat(b), []);
        return dataFields;
    }

    public static getDataFieldValues(datafieldGroups: DataFieldGroup[], includeEmptyFields: boolean): DataFieldValue[] {
        const values = DataFieldGroup.getDataFields(datafieldGroups)
            .filter(e => !e.IsHidden && (includeEmptyFields || e.Value || e.SecretId))
            .map(e => DataFieldValue.FromDataField(e));
        return values;
    }
}
